import {RouteProps} from 'config/navigation';

import PermissionGroup from './permission-groups';
import CreatePermissionGroup from './create-permission-group';
import EditPermissionGroup from './edit-permission-group';
import {MdOutlineSecurity} from 'react-icons/md';

const permissionGroupsPages: RouteProps = {
  name: 'Grupo de permissões',
  path: 'permission-groups',
  permission: 'permissionGroups.findAll',
  icon: <MdOutlineSecurity />,
  subRoutes: [
    {
      path: '',
      element: <PermissionGroup />,
      permissions: ['permissionGroups.findAll'],
    },
    {
      path: 'create',
      element: <CreatePermissionGroup />,
      permissions: ['permissionGroups.create'],
    },
    {
      path: ':id',
      element: <EditPermissionGroup />,
      permissions: ['permissionGroups.findOne'],
    },
  ],
};

export default permissionGroupsPages;
